export const invitationsSelector = (organizationKey) => state => state.invitations[organizationKey];

export const invitationSelector = (organizationKey, invitationKey) => state => {
    if (!Boolean(organizationKey) || !Boolean(invitationKey)) {
        return null;
    }

    return state.invitations[organizationKey]?.find(t => t.sk === invitationKey)
};